<template>
  <div class="form-group">
    <label class="layout-label-option label-option">
      {{ $i18nPresenter.t('Layout') }}
      <span class="title-table-presentation-tooltip result-layout-tooltip tooltip-on-hover">
        <b-button v-tooltip="$i18nPresenter.t('Choose how the result should be displayed')" class="tooltip-btn" />
        <i class="fas fa-question-circle" />
      </span>
    </label>
    <div class="mc-types-box">
      <div
        class="bars-box"
        v-for="(item,index) in chartTypes"
        :key="item.type"
        @click="selectChartTypes(item,index)"
        :class="{active: slideActive.typeChart == item.type}"
      >
        <div
          class="bars-box-content vertical center-justified layout"
          v-tooltip="item.type !== 'barChart' ?
            $i18nPresenter.t('Images currently do not show in this layout') : null"
        >
          <i :class="item.icon" v-if="item.type != 'donutChart'" class="text-light-gray" />
          <div class="mx-auto donutChartIcon-wrapper" v-else>
            <img
              src="../../assets/images/icon/donutcharticon-active.png"
              class="donutChartIcon"
              v-if="slideActive.typeChart == item.type"
            >
            <img src="../../assets/images/icon/donutcharticon.png" class="donutChartIcon" v-else>
          </div>
          <p
            class="box-type-label"
            :class="{'donut-label': item.type == 'donutChart'}"
          >
            {{ $i18nPresenter.t(item.name) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import Constant from '@/constant'
import Socket from '@/socket'
import Util from '@/util'
import SlideApi from '@/api/slide'
import eventCategories from '@/constant/eventCategories'

export default {
  data() {
    return {
      chartTypes: [],
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },
  created() {
    Object.keys(Constant.chartTypes).forEach((item) => {
      this.chartTypes.push(Constant.chartTypes[item])
    })
  },

  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),

    async selectChartTypes(item) {
      try {
        this.updateSlideActiveAction({
          typeChart: item.type,
        })
        this.setSyncLoadingAction(1)
        SlideApi.updateSlideById(this.slideActive.id, {
          typeChart: item.type,
          presentationId: this.$store.state.presentation.id,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        })
        Util.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Side right > Layouts > Change layout',
          `Layout: ${item.type}`,
        )
        this.setSyncLoadingAction(2)
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncLoadingAction(3)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.layout-label-option {
  margin: 0 0 10px;
}
.mc-types-box {
  overflow: hidden;
  display: flex;
}
.bars-box {
  float: left;
  width: 110px;
  margin-right: 10px;
  border: 1px solid #d0d0d0;
  color: #d0d0d0;
  text-align: center;
  border-radius: 4px;
  margin-bottom: 10px;

  &:hover {
    border: 1px solid $primary-color;
    cursor: pointer;
  }
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  .bars-box-content {
    padding: 8px 0 5px 0;
    height: 75px;
  }
  .box-type-label {
    margin: 0;
    font-size: 14px;
  }
  .donutChartIcon-wrapper {
    height: 19.9px;
    .donutChartIcon {
      max-height: 100%;
      max-width: 100%;
    }
  }
  .donut-label {
    margin: 0.5px 0;
  }
}
// .donutChartIcon {
//     content: url("../../assets/images/icon/donutcharticon2.png");
//   }
.active {
  border: 1px solid $primary-color;
  .fas, .far, .box-type-label {
    color: $primary-color !important;
  }
  &:hover {
    border: 1px solid $primary-color;
    cursor: pointer;
  }
}
</style>
